import { useEffect, useRef } from 'react';

export function useScrollToTopAnimation(openedAccordionIndex: number | null) {
  const accordionRootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (openedAccordionIndex === null) {
      return;
    }
    const activeElement = accordionRootRef.current?.children[openedAccordionIndex];
    if (!activeElement) {
      return;
    }

    if (activeElement.getBoundingClientRect().top < 0) {
      setTimeout(() => {
        activeElement.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      }, 250);
    }
  }, [openedAccordionIndex]);

  return accordionRootRef;
}
